import cx from 'classnames';
import { useRef } from 'react';

import rewriteSrc from '~/utils/rewriteSrc';

type AspectRatio = 'social' | 'square' | 'video';

interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  maxWidth: number;
  alt: string;
  aspectRatio: AspectRatio;
  widthClass?: string;
}

const Image = ({ src: prevSrc, alt, maxWidth, aspectRatio, widthClass, ...rest }: Props) => {
  const ref = useRef<HTMLImageElement | null>(null);

  // TODO: Try to resolve async
  // const entry = useIntersectionObserver(ref, { freezeOnceVisible: true });
  // const isVisible = Boolean(entry?.isIntersecting);

  const aspectRatioClass = {
    social: 'aspect-social',
    square: 'aspect-square',
    video: 'aspect-video',
  }[aspectRatio];

  const [x, y] = {
    social: [1.9, 1],
    square: [1, 1],
    video: [16, 9],
  }[aspectRatio];

  const width = maxWidth;
  const height = Math.round((width / x) * y);

  const src = rewriteSrc(prevSrc, {
    format: 'auto',
    width: String(width),
    height: String(height),
    fit: 'scale-down',
    onerror: 'redirect',
  });

  //
  // const lowResSrc = rewriteSrc(prevSrc, {
  //   format: "auto",
  //   width: String(width / 2),
  //   height: String(height / 2),
  //   fit: "scale-down",
  //   blur: "100",
  //   quality: "20",
  //   onerror: "redirect",
  // });

  return (
    <figure
      className={cx(aspectRatioClass, 'relative h-full overflow-hidden', widthClass ? widthClass : 'w-full')}
      ref={ref}
    >
      <img
        {...rest}
        width={width}
        height={height}
        src={src}
        alt={alt}
        className="absolute inset-0 h-full w-full object-cover"
      />
    </figure>
  );
};

export default Image;
